// @ts-expect-error Tools file is in JS
import Tools from '../Tools/Tools';

/**
 * Progress bar (červená linka na vrcholu stránky podle reportera/youtube apod.).
 * Třída je typu SINGLETON!
 */
class ProgressBar {
	static #instance: ProgressBar | null = null;

	readonly #bar: HTMLDivElement;
	#loadersQueue: string[] = [];
	#intervalID: number | null = null;
	#count = 0;

	constructor() {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Introduced in TP-10066.
		this.#bar = Tools.createElement('div', { class: 'ProgressBar' });

		if (!ProgressBar.#instance) {
			// Může být požadavek zobrazit několik loaderů najednou => nechceme!
			// Progress bar umístěný pod body.
			document.body.appendChild(this.#bar);

			ProgressBar.#instance = this;

			return this;
		}

		return ProgressBar.#instance;
	}

	/**
	 * Zobrazí progress bar.
	 * Pokud je nějaký aktivní, tak další přidá do fronty.
	 */
	start(progressName: string) {
		if (this.#loadersQueue.length) {
			this.#loadersQueue.push(progressName);

			return;
		}

		this.#updateProgress(1);
		this.#showBar();

		this.#intervalID = window.setInterval(this.#autoIncrement, 300);

		this.#loadersQueue.push(progressName);
	}

	/**
	 * Dokončí progress bar -> dojede až do konce POKUD
	 * už není žádný ve frontě.
	 */
	complete(progressName: string) {
		this.#removeProgressFromQueue(progressName);

		if (this.#loadersQueue.length === 0) {
			this.#updateProgress(100);
			this.#hideAfterWhile();
		}
	}

	#removeProgressFromQueue(progressName: string) {
		this.#loadersQueue = this.#loadersQueue.filter(
			(loader) => loader !== progressName,
		);
	}

	#hideAfterWhile() {
		if (this.#intervalID) {
			clearInterval(this.#intervalID);
		}

		// Počká, než se progress bar přiblíží ke konci (nechá doběhnout animaci). Pak ho schová.
		setTimeout(() => {
			this.#hideBar();
			this.#updateProgress(0);
		}, 600);
	}

	/**
	 * Simuluje průběh progress baru.
	 */
	#autoIncrement = () => {
		if (this.#count > 100) {
			// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression -- Introduced in TP-9489.
			return this.#hideAfterWhile();
		}

		this.#count += 0.15 * Math.pow(1 - Math.sqrt(100 - this.#count), 2);

		this.#updateProgress(this.#count);
	};

	/**
	 * Změní průběh progress baru (viditelnost červeného pruhu).
	 */
	#updateProgress(progress: number) {
		this.#count = progress;
		// eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Introduced in TP-10066.
		this.#bar.style.width = `${this.#count}%`;
	}

	#hideBar() {
		this.#bar.style.opacity = '0';
	}

	#showBar() {
		this.#bar.style.opacity = '1';
	}
}

export default ProgressBar;
